/** @jsxImportSource @emotion/react */
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt'
import { Card, CardContent, List, Typography, useTheme, Box } from '@mui/material'
import { useFetchAdminEmailDomains } from '../hooks/useFetchAdminEmailDomains'
import AdminCardLoading from './Admin.CardLoading'
import { cardContent, cardTitle, metricCard } from '../styles/Admin.styles'

interface TotalUsersCardProps {
  count: number
  title: string
}

export const AdminApprovedDomainCard = ({ title }: TotalUsersCardProps) => {
  const theme = useTheme()
  const { data: approvedEmailDomains = [], isLoading: isLoadingDomains } =
    useFetchAdminEmailDomains()

  if (isLoadingDomains) return <AdminCardLoading />

  return (
    <Card css={metricCard()}>
      <CardContent css={cardContent}>
        {/* Header section with title + icon */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2" css={cardTitle}>
            {title}
          </Typography>

          <ThumbUpAltIcon
            sx={{
              color: theme.palette.blue.main,
              opacity: 1,
              fontSize: 26,
            }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} css={cardTitle}>
          {approvedEmailDomains.length ?? '-'}
        </Typography>

        <List sx={{ maxHeight: 100, overflowY: 'auto', mt: 1, pr: 1 }}>
          {approvedEmailDomains.map((domain) => (
            <Typography key={domain} variant="body2" color="text.secondary">
              {domain}
            </Typography>
          ))}
        </List>
      </CardContent>
    </Card>
  )
}
